export const downloadFile = (fileName: string, content: string, blobType: string) => {
  const blob = new Blob([content], { type: blobType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};
